import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { EventCountCommand } from '../../../../commands/accounts/create.account.command';
import { BaseComponent } from '../../../../common/components/base.component';
import { AccountApiService } from '../../../../services/account.api.service';
import { AlertifyService } from '../../../../services/alertify.service';
import { EventCountModalData } from './event.count.modal.provider';

@Component({
  templateUrl: './event.count.modal.component.html',
  styleUrls: ['./event.count.modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EventCountModalComponent extends BaseComponent implements OnInit {
  public loading = false;
  public savingContract = false;
  public count: EventCountCommand;
  public tiers: any[] = [];
  public contract: any = {};
  public periodType: 'calendar' | 'contract' = 'contract';
  public selectedYear: number;
  public error = '';
  public sourceKeys = ['facebook', 'eventbrite', 'serpGoogle', 'aiAggregator'];

  constructor(
    private accountApiService: AccountApiService,
    private alertify: AlertifyService,
    private dialogRef: MatDialogRef<EventCountModalComponent>,
    public data: EventCountModalData,
  ) {
    super();
  }

  public ngOnInit() {
    this.loading = true;
    this.accountApiService.getEventSubscriptionTiers().subscribe((tiers) => {
      this.tiers = tiers || [];
      this.loadContractAndCount();
    }, () => this.loadContractAndCount());
  }

  public loadCount(year?: number) {
    this.loading = true;
    this.error = '';
    this.accountApiService.getEventCount(this.data.account.userName, this.periodType, year)
      .finally(() => this.loading = false)
      .subscribe((count) => {
        this.count = count;
        this.selectedYear = count.deliveryStatistics.period.anchorYear;
      }, (error) => {
        this.error = error && error.error && error.error.message
          ? error.error.message
          : 'Could not load event delivery statistics.';
      });
  }

  public changePeriod() {
    this.selectedYear = null;
    this.loadCount();
  }

  public changeYear() {
    this.loadCount(this.selectedYear);
  }

  public saveContract() {
    if (!this.contract.subscriptionTierId || !this.contract.contractStartDate) {
      this.alertify.error('Select a subscription tier and contract start date.');
      return;
    }
    this.savingContract = true;
    this.accountApiService.saveEventContract(this.data.account.userName, {
      subscriptionTierId: this.contract.subscriptionTierId,
      contractStartDate: this.contract.contractStartDate,
    }).finally(() => this.savingContract = false).subscribe((contract) => {
      this.contract = contract;
      this.contract.contractStartDate = this.toDateInput(contract.contractStartDate);
      this.periodType = 'contract';
      this.alertify.successfully('Event contract settings saved.');
      this.loadCount();
    });
  }

  public displayRun(run: any) {
    return run && run.completedAt ? new Date(run.completedAt).toLocaleString() : 'N/A';
  }

  public duration(ms: number) {
    if (ms === null || ms === undefined) return 'N/A';
    const seconds = Math.round(ms / 1000);
    if (seconds < 60) return `${seconds}s`;
    const minutes = Math.floor(seconds / 60);
    return `${minutes}m ${seconds % 60}s`;
  }

  public sourceName(key: string) {
    return ({ facebook: 'Facebook', eventbrite: 'Eventbrite', serpGoogle: 'Serp Google', aiAggregator: 'AI Event Aggregator' })[key] || key;
  }

  public reportingYearLabel(year: number) {
    if (this.periodType !== 'contract' || !this.contract.contractStartDate) return String(year);
    const dateParts = String(this.contract.contractStartDate).split('-');
    const startMonth = Number(dateParts[1]);
    if (!Number.isInteger(startMonth) || startMonth < 1 || startMonth > 12) return String(year);
    const endMonth = startMonth === 1 ? 12 : startMonth - 1;
    const endYear = startMonth === 1 ? Number(year) : Number(year) + 1;
    return `${year}.${startMonth} - ${endYear}.${endMonth}`;
  }

  public alertStatus(threshold: number) {
    const contract = this.count && this.count.deliveryStatistics
      ? this.count.deliveryStatistics.contract
      : null;
    const alerts = contract && contract.alerts ? contract.alerts : [];
    const alert = alerts.find((item) => item.threshold === threshold);
    if (alert) {
      return alert.status === 'sent' && alert.sentAt
        ? `sent ${new Date(alert.sentAt).toLocaleString()}`
        : alert.status;
    }
    const reached = contract && (threshold === 70
      ? contract.reached70Percent
      : contract.reached100Percent);
    return reached ? 'pending' : 'not reached';
  }

  public close() {
    this.dialogRef.close();
  }

  private toDateInput(value: string | Date) {
    const date = new Date(value as any);
    return isNaN(date.getTime()) ? '' : date.toISOString().slice(0, 10);
  }

  private loadContractAndCount() {
    this.accountApiService.getEventContract(this.data.account.userName).subscribe((contract) => {
      this.contract = contract || {};
      if (this.contract.contractStartDate) {
        this.contract.contractStartDate = this.toDateInput(this.contract.contractStartDate);
      } else {
        this.periodType = 'calendar';
      }
      this.loadCount();
    }, () => {
      this.periodType = 'calendar';
      this.loadCount();
    });
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/admin/accounts/event.count/event.count.modal.component.ts